import { FunctionComponent, useEffect } from 'react';
import '../news.scss';
import DIV from '../../shared/html-tags/div';

export type Props = {
  postLink: string | undefined;
  setNewsPostTitle: (title: string) => void;
};

const NewsPSImagoPro9: FunctionComponent<Props> = (props) => {
  useEffect(() => {
    const postLink = 'ps-imago-pro-9';
    const postTitle = "PS IMAGO PRO 9 /// WHAT'S NEW";

    if (props.postLink === postLink) {
      const setNewsPostTitle = props.setNewsPostTitle;
      setNewsPostTitle(postTitle);
    }
  }, [props.postLink, props.setNewsPostTitle]);

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      {props.postLink === 'ps-imago-pro-9' && (
        <>
          <DIV language="de" className="news-post">
            Nutzer von PS IMAGO PRO 9.0 profitieren von noch mehr neuen Funktionen, die die
            Möglichkeiten von IBM SPSS Statistics erweitern. Darunter befinden sich Verfahren für
            Datenoperationen sowie ein neuer Visualisierungstyp – ein Matrix-Dashboard. PS IMAGO PRO
            9.0 ist ausgestattet mit der neuesten IBM SPSS Statistics 29 Analyse-Engine und damit
            einer Reihe neuer Funktionen und Verfahren, darunter Accelerated Failure Time Modelle
            (AFT), eine Alternative zur linearen OLS und ein Violin-Diagramm. Zusätzlich zu den
            Verbesserungen in der Datenanalyse wurde auch die Leistung und Stabilität der Software
            in Bezug auf die neuesten Betriebssysteme verbessert.
            <h2>NEUE VERFAHREN UND EIN DIAGRAMM IM PREDICTIVE SOLUTIONS-MENÜ</h2>
            <h3>Verfahren für Datenmanagement und -verarbeitung</h3>
            <ul>
              <li>
                <b>MULTIPLY OBSERVATIONS</b> – damit kannst du Beobachtungen mithilfe einer
                Gewichtungsvariablen vervielfachen und an einem angegebenen Ort als neuen Datensatz
                speichern. Jeder Fall wird im neuen Datensatz so oft dargestellt, wie es seine
                gewichtete Häufigkeit im Originaldatensatz angibt;
              </li>
              <li>
                <b>REVERSE THE ENCODING</b> – damit kannst du die Richtung der Kodierung von
                Qualitätsvariablen umkehren. Das Verfahren kodiert die Variablen in neue Variablen
                mit entsprechenden Wertelabels um;
              </li>
              <li>
                <b>DATA AUDIT</b> – es hilft dir, eine Zusammenfassung für die analysierten
                Variablen in Form von Tabellen mit von dir ausgewählten Statistiken zu erstellen.
                Die Zusammenfassung wird mit einer Aufgliederung in quantitative und qualitative
                Variablen präsentiert. Dieses Verfahren ist besonders nützlich, wenn du einen
                schnellen Bericht erstellen oder mehrere Variablen vergleichen möchtest.
                <br />
                <img
                  src="/img/news/ps-imago-pro-9/data-audit.png"
                  alt="Data Audit-Ausgabe"
                  style={{ maxWidth: '60rem', margin: '2rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Data Audit – ein Beispielsatz von Zusammenfassungsstatistiken für quantitative und
                  qualitative Variablen
                </div>
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>Neues Dashboard</h3>
            <ul>
              <li>
                <strong>MATRIX DASHBOARD</strong>
                <br />– damit kannst du den Stand der Umsetzung eines Plans innerhalb von
                Daten-Gruppen/Untergruppen in Form eines Dashboards darstellen. Es fasst die
                aktuellen Werte der Aufgabenausführung mit den in einer Tabelle geplanten Werten
                zusammen. Je nach gewählter Vorlage repräsentiert die Farbgebung der Elemente
                und/oder ihre Form den Überschuss über Schwellenwerte oder den Stand der Umsetzung
                eines Plans.
                <br />
                <img
                  src="/img/news/ps-imago-pro-9/matrix-dashboard.png"
                  alt="Matrix-Dashboard"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Matrix-Dashboard – Verkäufe einzelner Produkttypen in Regionen
                </div>
              </li>

              <li>
                <b>EINE NEUE PLATTFORM ZUM ERGEBNISSHARING</b>
                <br />
                Die neue Version von PS IMAGO PRO integriert sich mit einem externen Microsoft
                SharePoint-Repository, das es dir ermöglicht, direkt über die Programmoberfläche auf
                diese zusätzliche Content-Sharing-Plattform zuzugreifen. Sobald der analytische
                Bericht in PS IMAGO PRO erstellt wurde, kannst du wählen, ob du ihn im PS IMAGO
                Portal oder in Microsoft SharePoint veröffentlichen möchtest.
                <br />
                <img
                  src="/img/news/ps-imago-pro-9/sharepoint.png"
                  alt="Korrelationskarte"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Das Programm-Dialogfeld zur Konfiguration der Berichtsveröffentlichung in
                  Microsoft SharePoint
                </div>
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h2>NEUE IBM SPSS STATISTICS 29 ANALYTISCHE ENGINE</h2>
            <h3>Neue und aktualisierte statistische Verfahren</h3>
            <ul>
              <li>
                <strong>ALTERNATIVEN ZU LINEARER OLS (Methode der kleinsten Quadrate)</strong>
                <br />– neue Regressionsarten: Lasso, Ridge Regression und Elastic Net, die zur
                Gruppe der regularisierten Regression gehören. Diese werden verwendet, um bei sehr
                komplexen Modellen „Strafen“ zu verhängen, und können hilfreich sein, um Variablen
                zu entfernen, die in einem Modell nicht sehr nützlich sind (nützlich bei einer hohen
                Anzahl von Prädiktoren oder deren Korrelation);
              </li>
              <li>
                <strong>ACCELERATED FAILURE TIME (AFT) MODELS</strong>
                <br />– eine neu hinzugefügte Überlebensanalyse, die ein parametrisches Modell ist,
                im Gegensatz zu der beliebten Kaplan-Meier- und Cox-Regression. Sie wird verwendet,
                wenn eine abhängige Variable einer bestimmten Verteilung folgt;
              </li>
              <li>
                <strong>VIOLIN PLOT</strong>
                <br />– ein neuer Diagrammtyp zur Visualisierung der Verteilung quantitativer Daten
                zusammen mit Zusammenfassungsstatistiken. Er basiert auf einem symmetrischen
                Dichtediagramm der Verteilung, das in Bezug auf die vertikale Achse dargestellt
                wird;
              </li>
              <li>
                <strong>
                  PSEUDO-R<sup>2</sup>-MESSUNGEN UND INTRA-CLASS-KORRELATIONSKOEFFIZIENT (ICC)
                </strong>
                <br />– berücksichtigt in den Ausgabedaten im Mixed Models-Verfahren – Lineare und
                Generalisierte Mixed Models.
                <br />
                <img
                  src="/img/news/ps-imago-pro-9/ridge-regression.png"
                  alt="Ridge Regression"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Ridge Regression – ein Liniendiagramm, das die Ridge-Regression-Koeffizienten und
                  den Alpha-Wert zeigt
                </div>
                <img
                  src="/img/news/ps-imago-pro-9/violin-plot.png"
                  alt="Violin-Diagramm"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Violin Plot – Verteilung der Price-Variable für einzelne Kategorien der
                  Region-Variable
                </div>
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>Analystenhilfen</h3>
            <ul>
              <li>
                <strong>NON-SELECTED OBSERVATIONS AVAILABLE</strong>
                <br />– nachdem eine Teilmenge von Beobachtungen ausgewählt wurde, werden die nicht
                ausgewählten Fälle im Data Editor nicht automatisch ausgeblendet oder verworfen;
              </li>
              <li>
                <strong>FOLDER MODE IMPROVEMENTS</strong>
                <br />– dem Ordner-Toolbar wurden zwei neue Elemente hinzugefügt: Die gesamte Syntax
                anzeigen/ausblenden und alle Ausgabedaten löschen. In der Statusleiste steht
                außerdem ein neuer Button zur Verfügung, mit dem du zwischen dem Classic-Modus
                (Befehls- und Ergebnisfenster) und dem Folder-Modus wechseln kannst;
              </li>
              <li>
                <strong>BROWSING IMPROVEMENTS</strong>
                <br />– die Suchfunktion ermöglicht es dir nun, Begriffe direkt in das Toolbar-Feld
                einzugeben und die Ergebnisse aus einer Dropdown-Liste anzuzeigen;
              </li>
              <li>
                <strong>PYTHON UND R UPDATES</strong>
                <br />– zusammen mit IBM SPSS Statistics 29 werden Python 3.10.4 und 4.2.0
                installiert.
                <img
                  src="/img/news/ps-imago-pro-9/folder-mode.png"
                  alt="Folder Mode"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Folder Mode – Integrierte Funktionen des Befehlsfensters und des Ergebnisfensters
                </div>
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>Verbesserungen für einzelne Verfahren</h3>
            <ul>
              <li>
                <strong>LINEARE REGRESSION</strong>
                <ul>
                  <li>
                    <strong>SELECTION CRITERIA</strong> im Statistik-Fenster – Ermöglicht die
                    Ausgabe in der Zusammenfassung: Akaike-Informationskriterium, Amemiyas
                    Vorhersagekriterium, Mallows' Vorhersagekriterium und das
                    Schwarz-Bayesian-Kriterium.
                  </li>
                  <li>
                    <strong>TOLERANCE</strong> im Options-Fenster – Ein Toleranztest ermöglicht zu
                    beurteilen, ob die Variablen die Mindestanforderungen erfüllen, um in die
                    Regressionsgleichung aufgenommen zu werden, wobei ihre Unabhängigkeit von
                    anderen Variablen berücksichtigt wird.
                  </li>
                  <li>
                    <strong>PRESS (Predicted Residual Sum of Squares) Residuen</strong> im
                    Statistik-Fenster – Ermöglicht die Bewertung der Anpassungsqualität des
                    Regressionsmodells.
                  </li>
                </ul>
              </li>
              <li>
                <strong>YOUDEN'S INDEX FÜR ROC-KURVEN</strong> – Ermöglicht die Bewertung der
                Klassifikation jedes Schnittpunkts der ROC-Kurve unter Berücksichtigung von
                Sensitivität und Spezifität.
              </li>
              <li>
                <strong>EXPORT VON RANDOM EFFECTS PREDICTIONS (EBLUPS)</strong> – Die Möglichkeit,
                den Inhalt von EBLUP-Ergebnistabellen in Datensätze oder .sav-Dateien in
                Mischmodellverfahren zu exportieren (
                <strong>Analyse &gt; Gemischte Modelle &gt; Linear oder Generalized Linear</strong>
                ).
              </li>
              <li>
                <strong>COX-REGRESSION</strong> – Das Fenster dieses Überlebensanalyse-Verfahrens
                wurde neu gestaltet und ermöglicht nun die Spezifikation und Berechnung mehrerer
                zeitabhängiger Kovariaten für Cox-Regression-Modelle.
              </li>
            </ul>
          </DIV>

          <DIV language="en" className="news-post">
            Users of PS IMAGO PRO 9.0 will benefit from yet more new features that expand the
            capabilities of IBM SPSS Statistics. Among them are procedures for data operations, as
            well as a new type of visualization – a matrix dashboard. PS IMAGO PRO 9.0 comes
            equipped with the latest IBM SPSS Statistics 29 analysis engine, and with it a number of
            new features and procedures, including Accelerated Failure Time models (AFT), an
            alternative to linear OLS, and a violin chart. In addition to data analysis
            enhancements, the software's performance and stability with respect to the latest
            operating systems has also been improved.
            <h2>NEW PROCEDURES AND A PLOT IN THE PREDICTIVE SOLUTIONS MENU</h2>
            <h3>Procedures for Data Management and Processing</h3>
            <ul>
              <li>
                <b>MULTIPLY OBSERVATIONS</b> – this allows multiplying observations with the use of
                a weighting variable, and saving them in a specified location in the form of a new
                dataset. Each case will be represented in the new set of data as many times as
                implied by its weighted frequency in the original set;
              </li>
              <li>
                <b>REVERSE THE ENCODING</b> – this allows reversing the direction of the encoding of
                quality variables. The procedure re-codes the variables into new variables with
                respective value labels;
              </li>
              <li>
                <b>DATA AUDIT</b> – it helps prepare a summary for the variables being analyzed in
                the form of tables with statistics selected by the user. The summary is presented
                with a breakdown into quantitative and qualitative variables. This procedure is
                particularly useful when creating a quick report or when comparing multiple
                variables.
                <br />
                <img
                  src="/img/news/ps-imago-pro-9/data-audit.png"
                  alt="Data Audit Output"
                  style={{ maxWidth: '60rem', margin: '2rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Data Audit – a sample set of summary statistics for quantitative and qualitative
                  variables
                </div>
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>New Dashboard</h3>
            <ul>
              <li>
                <strong>MATRIX DASHBOARD</strong>
                <br />– this makes it possible to present the status of implementing a plan within
                data groups /sub-groups in the form of a dashboard. It compiles the actual values of
                the execution of a task with the values planned in a table. Depending on the
                template chosen, the coloration of the items and/or their shape represents the
                excess over threshold values or over the status of a plan's implementation.
                <br />
                <img
                  src="/img/news/ps-imago-pro-9/matrix-dashboard.png"
                  alt="Matrix Dashboard"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Matrix dashboard - sales of individual types of products in regions
                </div>
              </li>

              <li>
                <b>A NEW PLATFORM FOR SHARING RESULTS</b>
                <br />
                The new version of PS IMAGO PRO integrates with an external Microsoft SharePoint
                repository allowing users to connect to this additional content sharing platform
                directly from the program's interface. Now, once the analytical report has been
                built in PS IMAGO PRO, the user can choose to publish it on either the PS IMAGO
                Portal or Microsoft SharePoint.
                <br />
                <img
                  src="/img/news/ps-imago-pro-9/sharepoint.png"
                  alt="Correlation Map"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  The program dialog box to configure report publishing in the Microsoft SharePoint
                </div>
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h2>NEW IBM SPSS STATISTICS 29 ANALYTICAL ENGINE</h2>
            <h3>New and updated statistical procedures</h3>
            <ul>
              <li>
                <strong>ALTERNATIVES TO LINEAR OLS (least squares methods)</strong>
                <br />– new regression types: Lasso, Ridge Regression, and Elastic Net, which are
                included in the regularized regression group. These are used to "impose penalties"
                on very complex models, and could be helpful in removing variables that are not very
                useful in a model (useful in the case of a high number of predictors, or their
                correlation);
              </li>
              <li>
                <strong>ACCELERATED FAILURE TIME (AFT) MODELS</strong>
                <br />– a newly added survival analysis, which is a parametric model, unlike the
                popular Kaplan-Meier and Cox regression. It is used when a dependent variable has a
                specified distribution;
              </li>
              <li>
                <strong>VIOLIN PLOT</strong>
                <br />– a new type of graph for visualizing the distribution of quantitative data
                along with summary statistics. It is based on a symmetrical distribution density
                plot, presented in respect of the vertical axis;
              </li>
              <li>
                <strong>
                  PSEUDO-R<sup>2</sup> MEASUREMENTS AND INTRA-CLASS CORRELATION COEFFICIENT (ICC)
                </strong>
                <br />– taken into consideration for the output data in the Mixed models procedure –
                Linear and Generalized Mixed Models.
                <br />
                <img
                  src="/img/news/ps-imago-pro-9/ridge-regression.png"
                  alt="Ridge Regression"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Ridge regression – a line chart showing the ridge regression coefficients and the
                  alpha value
                </div>
                <img
                  src="/img/news/ps-imago-pro-9/violin-plot.png"
                  alt="Violin Plot"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Violin Plot – distribution of the Price variable for individual categories of the
                  Region variable
                </div>
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>Analyst's Aides</h3>
            <ul>
              <li>
                <strong>NON-SELECTED OBSERVATIONS AVAILABLE</strong>
                <br />– after a subset of observations is selected, the non-selected cases are not
                hidden or rejected automatically in the Data Editor;
              </li>
              <li>
                <strong>FOLDER MODE IMPROVEMENTS</strong>
                <br />– two new elements were added to the folder toolbar: Show/Hide the whole
                syntax and Clear all the output data. On the status bar, a new button is also
                available for switching between the Classic mode (Commands and Results window), and
                the Folder mode;
              </li>
              <li>
                <strong>BROWSING IMPROVEMENTS</strong>
                <br />– the browsing function now offers entering terms directly in the toolbar
                field, and viewing the results from a drop-down list;
              </li>
              <li>
                <strong>PYTHON AND R UPDATES</strong>
                <br />- together with IBM SPSS Statistics 29, Python 3.10.4 and 4.2.0 are installed.
                <img
                  src="/img/news/ps-imago-pro-9/folder-mode.png"
                  alt="Folder Mode"
                  style={{ maxWidth: '50rem', margin: '1rem 0 0rem 0' }}
                />
                <div style={{ textAlign: 'center', fontSize: '0.75rem', marginBottom: '2rem' }}>
                  Folder Mode - Integrated functionalities of the Commands window and the Result
                  window
                </div>
              </li>
            </ul>
            {/* =========================================================================================== */}
            <hr />
            <h3>Improvements for Individual Procedures</h3>
            <ul>
              <li>
                <strong>LINEAR REGRESSION</strong>
                <ul>
                  <li>
                    <strong>SELECTION CRITERIA</strong> in the Statistics window – Allows obtaining
                    in the summary: Akaike Information Criterion, Amemiya's Prediction Criterion,
                    Mallows' Prediction Criterion, and Schwarz Bayesian Criterion.
                  </li>
                  <li>
                    <strong>TOLERANCE</strong> in the Options window – A tolerance test allows
                    assessing whether the variables meet the minimum requirements to be included in
                    the regression equation, considering their independence from other variables.
                  </li>
                  <li>
                    <strong>PRESS (Predicted Residual Sum of Squares) residuals</strong> in the
                    Statistics window – Allows evaluating the fit quality of the regression model.
                  </li>
                </ul>
              </li>
              <li>
                <strong>YOUDEN'S INDEX FOR ROC CURVES</strong> – Allows evaluating the
                classification of each cut point of the ROC curve, considering sensitivity and
                specificity.
              </li>
              <li>
                <strong>EXPORT RANDOM EFFECTS PREDICTIONS (EBLUPS)</strong> – The ability to export
                the contents of EBLUP result tables to datasets or .sav files in mixed model
                procedures (
                <strong>Analysis &gt; Mixed Models &gt; Linear or Generalized Linear</strong>).
              </li>
              <li>
                <strong>COX REGRESSION</strong> – The window of this survival analysis procedure has
                been redesigned, now allowing for the specification and calculation of multiple
                time-dependent covariates for Cox regression models.
              </li>
            </ul>
          </DIV>
        </>
      )}
    </>
  );
};

export default NewsPSImagoPro9;
